import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BCMCLPUser } from '../../../models/clpuser.model';
import { Country, CountryListResponse, CountryPlaceholder } from '../../../models/country-state.model';
import { DropDownItem, IntDropDownItem, SimpleResponse } from '../../../models/generic-response.model';
import { ClpCompany, ContactFields, ContactFieldsResponse, eSection, sectionDiplaySetting } from '../../../models/mem-contact-modal';
import { MemContact, REF_MemAssociationToPrimaryCaptain, REF_MemBoatingExperience, REF_MemCaptainType, REF_MemCSStatus, REF_MemGender, REF_MemRelationshipToEmergencyContact } from '../../../models/membership.model';
import { CountryStateService } from '../../../services/country-state.service';
import { MembershipService } from '../../../services/membership.service';
import { NotificationService } from '../../../services/notification.service';
import { GlobalService } from '../../../services/shared/global.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { PhoneFormatPipe } from '../../../pipes/phone-format.pipe';
import { isObject } from '@progress/kendo-angular-dropdowns/common/util';
import { ContactService } from '../../../services/contact.service';
@Component({
    selector: 'app-mem-contact',
    templateUrl: './mem-contact.component.html',
    styleUrls: ['./mem-contact.component.css'],
    providers: [PhoneFormatPipe]
})
/** mem-contact component*/
export class MemContactComponent {
    encryptedUser: string;
    showSpinner: boolean;
    memContactForm: FormGroup;
    contactForm = new FormGroup({});
    user: BCMCLPUser;
    contactId: number = 0;
    memContact: MemContact = <MemContact>{};
    countryCode: string = "US";
    companyData: ClpCompany;
    stateList: IntDropDownItem[];
    countryDD: Country[];
    memGender_List: REF_MemGender[];
    memCSStatus_List: REF_MemCSStatus[];
    memCaptainType_List: REF_MemCaptainType[];
    memAssociationToPrimaryCaptain_List: REF_MemAssociationToPrimaryCaptain[];
    memRelationshipToEmergencyContact_List: REF_MemRelationshipToEmergencyContact[];
    memBoatingExperience_List: REF_MemBoatingExperience[];
   
    
    //REF_MemGender
    constructor(private _localService: LocalService,
        private _globalService: GlobalService,
        private _utilityService: UtilityService,
        private fb: FormBuilder,
        private _router: Router,
        private _route: ActivatedRoute,
        private _memberShipService: MembershipService,
        private _countryStateService: CountryStateService,
        private datePipe: DatePipe,
        private _notifyService: NotificationService,
    ) {
        //this._localService.setShowMenu(false);
        //this._localService.setIsMembership(false);
        //this._localService.setIsCmManager(false);
        //this._localService.setIsCmSite(false);
        //this._localService.setRouteName("mem-contact");
    }
    ngOnInit() {
        const params = this._route.snapshot.params;
        if (params && +params['contactID'] > 0)
            this.contactId = +params['contactID'];
        this.memContactForm = this.prepareMemContactForm()
        this.getCountry();
        this.getCountryStateList(this.countryCode);
        

    }
    //#region mem-contact
    prepareMemContactForm() {
        return this.fb.group({
            contactID: [0],
            cLPCompanyID: [0],
            cLPUserID: [0],
            membershipIID: [0],
            genderID: [0],
            csStatusID: [0],
            captainTypeID: [0],
            birthdate: [''],
            socialSecurityNumber: [''],
            associationToPrimaryCaptainID: [0],
            onboardedByCLPUserID: [0],
            bookingSystemMembershipID: [0],
            bookingSystemUserID: [0],
            driversLicenseNumber: [''],
            emergencyContactName: [''],
            emergencyContactPhoneNumber: [''],
            relationshipToEmergencyContactID: [0],
            emergencyContactMailingStreet: [''],
            emergencyContactMailingStateID: [0],
            emergencyContactMailingCity: [''],
            emergencyContactMailingZip: [''],
            emergencyMailingCountryID: ['US'],
            lastBookingPortalActivity: [''],
            csatAverageScore: [0],
            dateOfLastReservation: [''],
            googleAnalyticsCampaign: [''],
            googleAnalyticsContent: [''],
            googleAnalyticsMedium: [''],
            googleAnalyticsSource: [''],
            googleAnalyticsTerm: [''],
            boatingExperienceID: [0],
            photoURL: [''],
            suspendedCaptain: [0],
        })
    }
    ngAfterViewInit() {
        this.encryptedUser = localStorage.getItem("token");
        if (this.encryptedUser) {
            this.authenticateR().then(() => {
                if (this.user) {
                    this.memGender_List = this._localService.refMem_GetAllResponse.ref_MemGender_List
                    this.memCSStatus_List = this._localService.refMem_GetAllResponse.ref_MemCSStatus_List
                    this.memCaptainType_List = this._localService.refMem_GetAllResponse.ref_MemCaptainType_List
                    this.memAssociationToPrimaryCaptain_List = this._localService.refMem_GetAllResponse.ref_MemAssociationToPrimaryCaptain_List
                    this.memRelationshipToEmergencyContact_List = this._localService.refMem_GetAllResponse.ref_MemRelationshipToEmergencyContact_List
                    this.memBoatingExperience_List = this._localService.refMem_GetAllResponse.ref_MemBoatingExperience_List
                    if (this.contactId > 0)
                        this.memContact_Get();                    
                }
                else {
                    this._router.navigate(['/unauthorized']);
                }
            });
        }
        else {
            this._router.navigate(['/unauthorized']);
        }
    }
    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    if (result?.strToken && result?.strToken != '') {
                        this.encryptedUser = result?.strToken;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    prepareMemContactRequest() {
        this.memContact.contactID = this.contactId;
        this.memContact.associationToPrimaryCaptainID = this.memContactForm?.get('associationToPrimaryCaptainID').value;
        this.memContact.birthdate = this.datePipe.transform(this.memContactForm.get('birthdate').value, 'MM/dd/yyyy');  
        this.memContact.boatingExperienceID = this.memContactForm?.get('boatingExperienceID').value;
        this.memContact.bookingSystemMembershipID = this.memContactForm?.get('bookingSystemMembershipID').value;
        this.memContact.bookingSystemUserID = this.memContactForm?.get('bookingSystemUserID').value;
        this.memContact.driversLicenseNumber = this.memContactForm?.get('driversLicenseNumber').value; 
        this.memContact.captainTypeID = this.memContactForm?.get('captainTypeID').value;
        this.memContact.clpCompanyID = this.user?.cLPCompanyID
        this.memContact.clpUserID = this.user?.cLPUserID
        this.memContact.csatAverageScore = this.memContactForm?.get('csatAverageScore').value;
        this.memContact.csStatusID = this.memContactForm?.get('csStatusID').value;
        this.memContact.dateOfLastReservation = this.datePipe.transform(this.memContactForm?.get('dateOfLastReservation').value, 'MM/dd/yyyy');   //date
        this.memContact.emergencyContactMailingCity = this.memContactForm?.get('emergencyContactMailingCity').value;
        this.memContact.emergencyContactMailingStateID = this.memContactForm?.get('emergencyContactMailingStateID').value;
        this.memContact.emergencyContactMailingStreet = this.memContactForm?.get('emergencyContactMailingStreet').value;
        this.memContact.emergencyContactMailingZip = this.memContactForm?.get('emergencyContactMailingZip').value;
        this.memContact.emergencyContactName = this.memContactForm?.get('emergencyContactName').value;
        this.memContact.emergencyContactPhoneNumber = this.memContactForm?.get('emergencyContactPhoneNumber').value;
        this.memContact.emergencyMailingCountryID = this.memContactForm?.get('emergencyMailingCountryID').value;
        this.memContact.genderID = this.memContactForm?.get('genderID').value;
        this.memContact.googleAnalyticsCampaign = this.memContactForm?.get('googleAnalyticsCampaign').value;
        this.memContact.googleAnalyticsContent = this.memContactForm?.get('googleAnalyticsContent').value;
        this.memContact.googleAnalyticsMedium = this.memContactForm?.get('googleAnalyticsMedium').value;
        this.memContact.googleAnalyticsSource = this.memContactForm?.get('googleAnalyticsSource').value;
        this.memContact.googleAnalyticsTerm = this.memContactForm?.get('googleAnalyticsTerm').value;
        this.memContact.lastBookingPortalActivity = this.datePipe.transform(this.memContactForm?.get('lastBookingPortalActivity').value, 'MM/dd/yyyy');  
        this.memContact.membershipIID = this.memContactForm?.get('membershipIID').value;
        this.memContact.onboardedByCLPUserID = this.memContactForm?.get('onboardedByCLPUserID').value;
        this.memContact.photoURL = this.memContactForm?.get('photoURL').value;
        this.memContact.relationshipToEmergencyContactID = this.memContactForm?.get('relationshipToEmergencyContactID').value;
        this.memContact.socialSecurityNumber = this.memContactForm?.get('socialSecurityNumber').value;
        this.memContact.suspendedCaptain = this.memContactForm?.get('suspendedCaptain').value;


    }


    async memContact_Get() {
        this.showSpinner = true
        await this._memberShipService.memContact_Get(this.encryptedUser, this.contactId).
            then(async (result: MemContact) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.memContact = response;
                    this.patchContactFormValue();
                }
                this.showSpinner = false
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false
                this._globalService.error("mem-contact.memContact_Get", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    patchContactFormValue() {
        this.memContactForm.patchValue({
            contactID: this.memContact.contactID,
            cLPCompanyID: this.memContact.clpCompanyID,
            cLPUserID: this.memContact.clpUserID,
            membershipIID: this.memContact.membershipIID,
            genderID: this.memContact.genderID,
            csStatusID: this.memContact.csStatusID,
            captainTypeID: this.memContact.captainTypeID,
            birthdate: this.memContact.birthdate,
            socialSecurityNumber: this.memContact.socialSecurityNumber,
            associationToPrimaryCaptainID: this.memContact.associationToPrimaryCaptainID,
            onboardedByCLPUserID: this.memContact.onboardedByCLPUserID ?? 0,
            bookingSystemMembershipID: this.memContact.bookingSystemMembershipID ?? 0,
            bookingSystemUserID: this.memContact.bookingSystemUserID ?? 0,
            driversLicenseNumber: this.memContact.driversLicenseNumber,
            emergencyContactName: this.memContact.emergencyContactName,
            emergencyContactPhoneNumber: this.memContact.emergencyContactPhoneNumber,
            relationshipToEmergencyContactID: this.memContact.relationshipToEmergencyContactID,
            emergencyContactMailingStreet: this.memContact.emergencyContactMailingStreet,
            emergencyContactMailingStateID: this.memContact.emergencyContactMailingStateID ?? 0,
            emergencyContactMailingCity: this.memContact.emergencyContactMailingCity,
            emergencyContactMailingZip: this.memContact.emergencyContactMailingZip,
            emergencyMailingCountryID: this.memContact.emergencyMailingCountryID ?? 0,
            lastBookingPortalActivity: this.memContact.lastBookingPortalActivity,
            csatAverageScore: this.memContact.csatAverageScore,
            dateOfLastReservation: this.memContact.dateOfLastReservation,
            googleAnalyticsCampaign: this.memContact.googleAnalyticsCampaign,
            googleAnalyticsContent: this.memContact.googleAnalyticsContent,
            googleAnalyticsMedium: this.memContact.googleAnalyticsMedium,
            googleAnalyticsSource: this.memContact.googleAnalyticsSource,
            googleAnalyticsTerm: this.memContact.googleAnalyticsTerm,
            boatingExperienceID: this.memContact.boatingExperienceID,
            photoURL: this.memContact.photoURL,
            suspendedCaptain: this.memContact.suspendedCaptain
        });
    }

    memContact_Save() {
        //if (this.contactId == 0)
        //    this.memContact_Create();
        //else
            this.memContact_Update();
    }

    async memContact_Create() {
        this.prepareMemContactRequest();
        await this._memberShipService.memContact_Create(this.encryptedUser, this.memContact)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this._notifyService.showSuccess("Membership Contact Created successfully.", "", 3000);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("mem-contact.memContact_Create", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async memContact_Update() {
        this.prepareMemContactRequest();
        await this._memberShipService.memContact_Update(this.encryptedUser, this.memContact)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this._notifyService.showSuccess("Membership Contact Updated successfully.", "", 7000);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("mem-contact.MemContact_Update", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async MemContact_Delete(contactId) {
        await this._memberShipService.memContact_Delete(this.encryptedUser, contactId)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("mem-contact.MemContact_Delete", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getCountry() {
        await this._countryStateService.country_Get(this.encryptedUser)
            .then(async (result: CountryListResponse) => {
                if (result) {
                    let countryList = UtilityService.clone(result);
                    this.countryDD = countryList.countries;
                    this.countryDD?.unshift({
                        id: 0,
                        name: "--Select--",
                        code: "",
                        code2: "",
                        code2Lower: "",
                        dialCode: 0,
                        placeholder: ""
                    });
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }
    onChangeCountry(id) {
        let countryCode = this.countryDD.find(x => x.id == id).code2;
        this.getCountryStateList(countryCode)
    }

    async getCountryStateList(countryCode: string) {
        await this._countryStateService.getCountry_StateList_GetwithStateID(this.encryptedUser, countryCode ? countryCode : "US")
            .then(async (result: IntDropDownItem[]) => {
                if (result) {
                    this.stateList = UtilityService.clone(result);
                    this.stateList?.unshift({
                        id: 0,
                        text: "--Select--"
                    });
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }
    //#endregion

}
